export const ForgotPasswrodConstants = {
  CODE_SENT: "CODE_SENT",
  PASSWORD_CHANGED: "PASSWORD_CHANGED",
};
